import { cn } from '@/lib/utils'

import { TabsList, TabsTrigger } from '@/components/ui/tabs'

export interface TabOption {
  label: string
  value: string
}

interface UnderlinedTabsListProps {
  tabs: TabOption[]
  className?: string
  triggerClassName?: string
}

export const UnderlinedTabsList = ({
  tabs,
  className,
  triggerClassName,
}: UnderlinedTabsListProps) => {
  return (
    <TabsList
      className={cn(
        'h-auto w-full flex-nowrap justify-start gap-0 overflow-x-auto whitespace-nowrap rounded-none border-b border-border bg-transparent p-0 scrollbar-hide',
        className
      )}
    >
      {tabs.map((tab) => (
        <TabsTrigger
          key={tab.value}
          value={tab.value}
          className={cn(
            '-mb-px h-10 rounded-none border-b-2 border-transparent px-4 hover:bg-transparent data-[state=active]:border-ink data-[state=active]:bg-transparent',
            triggerClassName
          )}
        >
          {tab.label}
        </TabsTrigger>
      ))}
    </TabsList>
  )
}
